import React from "react";

import { Footer, Header, Spinner } from "component-library";
import { dataTestIds } from "data-testids";

import { config } from "../../config/common";
import { getFooterContent } from "./Layout.helpers";

import { useUser } from "../../context/UserContext";
import useFetchNav from "../../hooks/useFetchNav";

interface ILayoutProps {
  children: React.ReactNode;
  removePadding?: boolean;
  hideFooter?: boolean;
}

const Layout: React.FC<React.PropsWithChildren<ILayoutProps>> = ({
  children,
  removePadding,
  hideFooter,
}) => {
  const { locale } = useUser();
  const { isLoading, data } = useFetchNav(locale);

  if (isLoading || !data) {
    return <Spinner />;
  }

  const footerConfig = getFooterContent(data.footer);

  return (
    <main>
      <section
        className="flex flex-col justify-between min-h-screen"
        data-testid={dataTestIds.joiningPages["Layout.layout"]}
      >
        <Header
          texts={{ logoLabel: data.header.menu }}
          logoLink={config.marketingSiteUrl}
          hideSignIn
          hideMobileMenu
        />
        <main
          className={`relative flex flex-col flex-1 text-base ${
            !removePadding && "pt-4"
          }`}
        >
          {children}
        </main>
        {!hideFooter && (
          <Footer
            navigationLinks={footerConfig.navigationLinks}
            texts={footerConfig.texts}
          />
        )}
      </section>
    </main>
  );
};

export default Layout;
